import React, { useMemo, useState } from 'react';
import { Button, Dragger, Icon, Modal } from '../../components/ui';
import { Modal as AntdModal } from 'antd';
import { useValidateBulkUnsubscribe } from '../../query/unsubscribe';
import { useBulkUnsubscribe } from '../../mutation/unsubscribe';

type ChildrenRenderArgs = {
  onClick: Function,
};

type Props = {
  children: (args: ChildrenRenderArgs) => React.ReactChildren,
};

export default function OpenBulkUnsubscribeButton(props: Props) {
  const [openModal, setOpenModal] = useState(false);
  const [file, setFile] = useState(null);
  const { data, isFetching: isValidating } = useValidateBulkUnsubscribe(file);
  const { mutate, isLoading: isUploading } = useBulkUnsubscribe();
  const isLoading = isValidating || isUploading;

  const renderCsvError = useMemo(() => {
    if (!data || data.valid) {
      return null;
    }
    return (
      <>
        {data.errors.map(({ row, message }) => {
          return (
            <div key={row} style={{ fontSize: 12, color: 'red', marginTop: 5 }}>
              Error at row {row}: {message}
            </div>
          );
        })}
      </>
    );
  }, [data]);

  const renderCsvUpload = useMemo(() => {
    return (
      <Dragger
        accept=".csv"
        beforeUpload={selectedFile => {
          setFile(selectedFile);
          return false;
        }}
        className="upload-csv-file__dragger"
        disabled={isLoading}
        fileList={file ? [file] : []}
        multiple={false}
        size="small"
        onRemove={() => setFile(null)}
      >
        Drop a CSV file here
        <br />
        or
        <br />
        <Button className="upload-csv-file__upload-btn" size="small">
          <Icon type={isLoading ? 'loading' : 'upload'} />
          <span className="upload-csv-file__btn-text">
            &nbsp; Click to upload file
          </span>
        </Button>
      </Dragger>
    );
  }, [file, isLoading]);

  return (
    <>
      {props.children({ onClick: () => setOpenModal(true) })}
      <Modal
        centered
        maskClosable={false}
        okButtonProps={{
          disabled: !file || !data || !data.valid || isLoading,
          loading: isUploading,
        }}
        okText="Upload"
        title="Bulk UnsubscribeOld Wizard"
        visible={openModal}
        width="70vw"
        onCancel={() => setOpenModal(false)}
        onOk={() =>
          AntdModal.confirm({
            title: 'Confirmation',
            content: `You are about to unsubscribe ${data?.totalRows} email addresses. Are you sure you want to continue?`,
            okText: 'Yes',
            okType: 'danger',
            onOk: async () => {
              await mutate(file);
              setFile(null);
              setOpenModal(false);
            },
            cancelText: 'No',
          })
        }
      >
        <p>
          Please upload a csv file.{' '}
          <a
            className="clickable"
            href="/bulk-unsubscribe-sample.csv"
            target="blank"
          >
            Click here to download input sample csv
          </a>
        </p>
        {renderCsvUpload}
        {renderCsvError}
      </Modal>
    </>
  );
}
